import { Instagram } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { translations } from "@/i18n/translations";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { language } = useLanguage();
  const t = translations[language].footer;
  const navT = translations[language].nav;

  return (
    <footer className="bg-card/30 backdrop-blur-sm border-t border-border py-8 sm:py-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 sm:gap-8 mb-6 sm:mb-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-xl sm:text-2xl font-bold text-primary mb-3 sm:mb-4">PlayfieldVR</h3>
            <p className="text-sm sm:text-base text-muted-foreground mb-3 sm:mb-4">
              {t.description}
            </p>
            <a 
              href="https://www.instagram.com/playfieldvr/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-card border border-border hover:border-primary transition-colors group"
            >
              <Instagram className="w-5 h-5 text-muted-foreground group-hover:text-primary transition-colors" />
              <span className="text-sm text-muted-foreground group-hover:text-primary transition-colors">
                {language === 'nl' ? 'Volg ons op Instagram' : 'Follow us on Instagram'}
              </span>
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-foreground mb-3 sm:mb-4 text-base sm:text-lg">{t.quickLinks}</h4>
            <ul className="space-y-1.5 sm:space-y-2 text-sm sm:text-base">
              <li>
                <Link to="/" className="text-muted-foreground hover:text-primary transition-colors">
                  {navT.home}
                </Link>
              </li>
              <li>
                <Link to="/experiences" className="text-muted-foreground hover:text-primary transition-colors">
                  {navT.experiences}
                </Link>
              </li>
              <li>
                <Link to="/#about" className="text-muted-foreground hover:text-primary transition-colors">
                  {navT.about}
                </Link>
              </li>
              <li>
                <Link to="/#contact-form" className="text-muted-foreground hover:text-primary transition-colors">
                  {navT.contact}
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-muted-foreground hover:text-primary transition-colors">
                  {t.faq}
                </Link>
              </li>
              <li>
                <Link to="/kennisbank" className="text-muted-foreground hover:text-primary transition-colors">
                  Kennisbank
                </Link>
              </li>
              <li>
                <Link to="/vr-teamuitje" className="text-muted-foreground hover:text-primary transition-colors">
                  VR teamuitje
                </Link>
              </li>
              <li>
                <Link to="/vr-personeelsuitje" className="text-muted-foreground hover:text-primary transition-colors">
                  VR personeelsuitje
                </Link>
              </li>
              <li>
                <Link to="/vr-borrelactiviteit-kantoor" className="text-muted-foreground hover:text-primary transition-colors">
                  Borrelactiviteit op kantoor
                </Link>
              </li>
              <li>
                <Link to="/vr-bedrijfsuitje" className="text-muted-foreground hover:text-primary transition-colors">
                  VR bedrijfsuitje
                </Link>
              </li>

              <li>
                <Link to="/vr-teambuilding-amsterdam" className="text-muted-foreground hover:text-primary transition-colors">
                  VR teambuilding Amsterdam
                </Link>
              </li>
              <li>
                <Link to="/vr-teambuilding-zaandam" className="text-muted-foreground hover:text-primary transition-colors">
                  VR teambuilding Zaandam
                </Link>
              </li>
              <li>
                <Link to="/vr-teambuilding-purmerend" className="text-muted-foreground hover:text-primary transition-colors">
                  VR teambuilding Purmerend
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold text-foreground mb-3 sm:mb-4 text-base sm:text-lg">{t.legal}</h4>
            <ul className="space-y-1.5 sm:space-y-2 text-sm sm:text-base">
              <li>
                <Link to="/privacy-policy" className="text-muted-foreground hover:text-primary transition-colors">
                  {t.privacyPolicy}
                </Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="text-muted-foreground hover:text-primary transition-colors">
                  {t.termsOfService}
                </Link>
              </li>
              <li>
                <Link to="/cookie-policy" className="text-muted-foreground hover:text-primary transition-colors">
                  {t.cookiePolicy}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 sm:pt-8 border-t border-border text-center text-muted-foreground text-sm sm:text-base">
          <p>&copy; {currentYear} PlayfieldVR. {t.copyright}</p>
          <p className="mt-2">KVK: 99031027</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
